



























































































































































































import Vue, { PropType } from 'vue';
import { IPaymentRequisition } from '@/models';
import { DataTableHeader } from 'vuetify';

export default Vue.extend({
  name: 'PaymentRequisitionDetail',

  props: {
    payrollChangeRequest: {
      type: Object as PropType<IPaymentRequisition>,
      required: true
    }
  },

  data: () => ({
    headers: [
      {
        text: 'From Department',
        value: 'from_department',
        sortable: false,
        class: 'primary white--text subtitle-1'
      },

      {
        text: 'To Department',
        value: 'to_department',
        sortable: false,
        class: 'primary white--text subtitle-1'
      },
      {
        text: 'From Group',
        value: 'from_group',
        sortable: false,
        class: 'primary white--text subtitle-1'
      },

      {
        text: 'To Group',
        value: 'to_group',
        sortable: false,
        class: 'primary white--text subtitle-1'
      },
      {
        text: 'From Rate',
        value: 'from_rate',
        align: 'center',
        sortable: false,
        class: 'primary white--text subtitle-1'
      },
      {
        text: 'To Rate',
        value: 'to_rate',
        align: 'center',
        sortable: false,
        class: 'primary white--text subtitle-1'
      }
    ] as DataTableHeader[]
  })
});
